import {
  FocusContext,
  ROOT_FOCUS_KEY,
} from "@noriginmedia/norigin-spatial-navigation";
import { type Store, StoreProvider } from "@sunrise/store";
import { TranslationProvider } from "@sunrise/translator";
import { QueryClient } from "@tanstack/query-core";
import { queryClientAtom } from "jotai-tanstack-query";
import { ReactNode } from "react";

import { QueryProvider } from "@/modules/query-provider";

export function AppProvider(props: {
  children: ReactNode;
  queryClient: QueryClient;
  enableDevTools: boolean;
  queryClientAtom: typeof queryClientAtom;
  storeInstance: Store;
}): ReactNode {
  return (
    <QueryProvider
      queryClientInstance={props.queryClient}
      enableDevTools={props.enableDevTools}
    >
      <StoreProvider
        store={props.storeInstance}
        enableDevTools={props.enableDevTools}
      >
        <TranslationProvider>
          <FocusContext.Provider value={ROOT_FOCUS_KEY}>
            {props.children}
          </FocusContext.Provider>
        </TranslationProvider>
      </StoreProvider>
    </QueryProvider>
  );
}
